<template>
  <app-button
    router
    :to="{ name: 'account-login', query: loginRedirectQuery }"
    theme="login"
    class="app-header-sign-in-link"
  >
    Sign In
  </app-button>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { getLoginRedirectQuery } from '@core/auth/utils'
import AppButton from '@modules/ui/app-button.vue'

const route = useRoute()
const loginRedirectQuery = computed(() => getLoginRedirectQuery(route))
</script>
